// import { faPersonWalkingDashedLineArrowRight } from "@fortawesome/free-solid-svg-icons";
import { action, makeObservable, observable } from "mobx";
import { privatePost } from "../utils/NetworkService";
import { getTokenBalance, getEtherBalance } from '../utils/TokenService';
// import { Navigate } from 'react-router-dom';


export class CoinStore {
    rootStore;
    LoginStore;
    loginState;

    WalletData = [];
    UserLockToken = [];
    UserCoinLockTokenValue = 0;
    UserCoinLockTokenDatainfo = [];
    CoinTransferData = [];
    ExchangeCommissionsData = [];
    ExchangeMemberStandData = [];
    NotCompleteDBExchangeReservationList = [];
    CompleteDBExchangeReservationList = [];
    NotCompleteTokenToCloverExchangeList = [];
    CompleteTokenToCloverExchangeList = [];

    StandData = 0;
    EtherData = 0;
    DBData = 0;
    TransformStandValue = 0;
    ExChangeKRW = 0;
    RealTokenToDBCommission = 0;


    DBExchangeDataValue = "";
    DBExchangeData = {};
    DBExchangeCommission = 0;

    WalletInput = '';
    StandInput = '';
    // GuideWallet = "전달할 지갑주소를 입력해주세요";
    // GuideStand = '전달 할 수량을 입력해 주세요!';
    GuideCommission = "";
    GuideEtherCoin = "";
    GuideStandCoin = "";
    GuideTransferMessage = "";




    Commission = "";
    CountEtherCoin = 0;
    SendButtonChange = 0;
    CalculationCoinChange = "0";
    WalletUpdateStart = false;

    isDBCoinTransferPage = true;
    isStandExchangePage = false;







    constructor(root) {
        makeObservable(this, {
            WalletData: observable,
            StandData: observable,
            UserLockToken: observable,
            Commission: observable,
            SendButtonChange: observable,
            WalletInput: observable,
            StandInput: observable,
            CoinTransferData: observable,
            WalletUpdateStart: observable,
            GuideCommission: observable,
            EtherData: observable,
            GuideEtherCoin: observable,
            GuideStandCoin: observable,
            DBData: observable,
            CountEtherCoin: observable,
            TransformStandValue: observable,
            ExchangeCommissionsData: observable,
            ExchangeMemberStandData: observable,
            GuideTransferMessage: observable,
            CalculationCoinChange: observable,
            isDBCoinTransferPage: observable,
            isStandExchangePage: observable,
            DBExchangeData: observable,
            DBExchangeCommission: observable,
            DBExchangeDataValue: observable,
            UserCoinLockTokenValue: observable,
            UserCoinLockTokenDatainfo: observable,
            NotCompleteDBExchangeReservationList: observable,
            CompleteDBExchangeReservationList: observable,
            NotCompleteTokenToCloverExchangeList: observable,
            CompleteTokenToCloverExchangeList: observable,
            ExChangeKRW: observable,
            RealTokenToDBCommission: observable,


            setUserCoinLockTokenState: action,// user get lockToken Count and State 
            getMemberLockTokenData: action,
            getDBExchangeValueCommission: action,
            setDBExchangeValueCommission: action,
            setDBExchangeValueStand: action,
            setDBExchangeDataValue: action,
            setisDBCoinTransfer: action,
            // SetCloverCoinSale: action,
            // getCloverCoinSale: action,
            CoinStoreTestCheck: action,
            setUserCalculationCoinChange: action,
            setCalculationCoinChange: action,
            setGuideTransferMessage: action,
            setCoinTransferData: action,
            setExchangeMemberStandData: action,
            setExchangeMemberStand: action,
            getExchangeCommissions: action,
            setDBData: action,
            getDBCoin: action,
            setEtherData: action,
            getEtherCoin: action,
            setWalletUpdateStart: action,
            WalletUpdate: action,
            CoinSendRefrash: action,
            errSendButtonChange: action,
            setSandCoinData: action,
            SandCoin: action,
            StandTextValue: action,
            WalletTextValue: action,
            getLockToken: action,
            getStandCoin: action,
            setCommissionEther: action,
            getCommissionEther: action,
            setUserLockToken: action,
            setStandData: action,
            getWalletData: action,
            setWalletData: action,
            setSendButtonChange: action,
            setExchangeReservationList: action,
            setTokenToCloverExchangeReservationList: action,
            setExchangeKRW: action,
            setRealTokenToDBCommission: action,
        });
        this.rootStore = root;
        this.LoginStore = root.loginStore;
        this.loginState = root.loginStore.loginState;

        this.WalletData = [];
        this.UserLockToken = [];
        this.UserCoinLockTokenValue = 0;
        this.UserCoinLockTokenDatainfo = [];
        this.CoinTransferData = [];
        this.ExchangeCommissionsData = [];
        this.ExchangeMemberStandData = [];

        this.NotCompleteDBExchangeReservationList = [];
        this.CompleteDBExchangeReservationList = [];
        this.NotCompleteTokenToCloverExchangeList = [];
        this.CompleteTokenToCloverExchangeList = [];


        this.StandData = 0;
        this.EtherData = 0;
        this.DBData = 0;
        this.CalculationCoinChange = "0";


        this.DBExchangeDataValue = "";
        this.DBExchangeData = {};
        this.DBExchangeCommission = 0;

        this.WalletInput = '';
        this.StandInput = '';
        // this.GuideWallet = "전달할 지갑주소를 입력해주세요";
        // this.GuideStand = '전달 할 수량을 입력해 주세요!';
        this.Commission = "";
        this.GuideCommission = "";
        this.GuideEtherCoin = "";
        this.GuideStandCoin = "";
        this.GuideTransferMessage = "";








        this.SendButtonChange = 0;
        this.CountEtherCoin = 0;
        this.WalletUpdateStart = false;

        this.isDBCoinTransferPage = true;
        this.isStandExchangePage = false;




    }

    CoinStoreTestCheck(d) {
        // console.log(d);
        // console.log(this.rootStore?.loginStore?.ErrorGuide_clover_coin_001);
        // return alert(this.rootStore?.loginStore?.ErrorGuide_clover_coin_001);

    }

    setSendButtonChange = (value) => {//버튼 바꾸기
        const Wallet = this.WalletInput;
        if (Wallet !== "" || Wallet !== undefined || Wallet !== null) {
            // eslint-disable-next-line
            if (value == "1") {
                this.SendButtonChange = 1;
            }
            // eslint-disable-next-line
            else if (value == "0") {
                this.SendButtonChange = 0;
            }
        }
        else {
            return alert(this.rootStore?.loginStore?.ErrorGuide_clover_coin_001);//지갑 주소를 확인해 주세요
        }
    }

    getDBCoin = (value) => {//DB코인 불러오기
        // const member_no = this.loginState.member_no;
        // const memberData = {member_no};
        const StandApi = '/getStandData';
        privatePost({ api: StandApi, data: { member_no: parseInt(this.rootStore.loginStore.loginState.member_no) } }, (err, response) => {
            if (err) {
                // console.log(err);
                // eslint-disable-next-line
                if (err.errorCode == 3200) {
                    alert(this.rootStore?.loginStore?.ErrorGuide_clover_userProfile_01);// 유저를 찾을 수 없습니다
                }
                // eslint-disable-next-line
                else if (err.errorCode == 3102) {
                    alert(this.rootStore?.loginStore?.ErrorGuide_clover_userProfile_02);// 등급이 해당되지 않습니다
                }
            } else {
                // console.log("getDBCoin",response?.data?.result);
                this.setDBData(response?.data?.result);
                return;
            }
        });

    }

    setDBData(DBCoinData) {
        const DBCoin = DBCoinData.stand_count;
        // console.log(DBCoin);
        // eslint-disable-next-line
        if (DBCoin == undefined) {
            this.DBData = 0;
        }
        // eslint-disable-next-line
        else if (DBCoin == null) {
            this.DBData = 0;
        }
        // eslint-disable-next-line
        else if (DBCoin == "") {
            this.DBData = 0;
        }
        // eslint-disable-next-line
        else if (DBCoin == 0) {
            this.DBData = 0;
        }
        else {
            this.DBData = DBCoin;
        }
    }



    getWalletData = (value) => {//지갑 데이터 불러오기
        const WalletApi = '/getWalletData';
        privatePost({ api: WalletApi, data: { member_no: parseInt(this.rootStore.loginStore.loginState.member_no) } }, (err, response) => {
            if (err) {
                // console.log(err); 
                this.LoginStore.setIsRecommenderPage(false);//MiningBar 보기            
            } else {
                // console.log("getWalletData",response?.data?.result);
                this.LoginStore.setIsRecommenderPage(true);//MiningBar 보기 
                this.setWalletData(response?.data?.result);
                this.getEtherCoin("WalletIN_EtherCoin");
                // this.getStandCoin("WalletIN_StandCoin");
                this.getLockToken("WalletIN_LockToken");
                this.getDBCoin("WalletIN_DBCoin");
                this.getExchangeCommissions("WalletIN_ExchangeCommissions");
                this.getExchangeCommissionWithWallet(); // 지갑 정보 with lock state
                this.rootStore.MiningStore.getUserMiningList("WalletINUserMiningList");

            }
        });
    }

    setWalletData(object) {//지갑데이터 변수에 저장
        this.WalletData = object;
        this.rootStore.UserProfileStore.FriendListShareBoolChange(object.business_code);
    }

    getLockToken = (value) => {// 락토큰 불러오기
        // console.log(value);
        // const member_no = this.loginState.member_no;
        // const memberData = {member_no};
        //DB lock data
        const UserLockTokenApi = '/getUserLockToken';
        if (this.rootStore.loginStore.loginState.member_no === undefined || this.rootStore.loginStore.loginState.member_no === null || this.rootStore.loginStore.loginState.member_no === "") {
            // console.log("DDDDD")
        }
        else {
            privatePost({ api: UserLockTokenApi, data: { member_no: parseInt(this.rootStore.loginStore.loginState.member_no) } }, (err, response) => {
                if (err) {
                    // console.log(err); 
                    // eslint-disable-next-line
                    if (err.errorCode == 3200) {
                        alert(this.rootStore?.loginStore?.ErrorGuide_clover_userProfile_01);// 유저를 찾을 수 없습니다
                    }
                    // eslint-disable-next-line
                    else if (err.errorCode == 3102) {
                        alert(this.rootStore?.loginStore?.ErrorGuide_clover_userProfile_02);// 등급이 해당되지 않습니다
                    }
                    return
                } else {
                    // console.log("getLockToken",response?.data?.result);
                    this.setUserLockToken(response?.data?.result);
                    return
                }
            });
        }
    }

    getStandCoin = (value) => {//Stand코인 불러오기
        // console.log(value);
        const address = this.WalletData.address;
        // console.log('getStandCoin===================================', address);
        if (address === undefined || address === null || address === "") {
            // console.log("address");
        }
        else {
            getTokenBalance(address, (err, response) => {//실제 코인 데이터 
                // console.log("getTokenBalance", response);
                // if(response?.data?.result === 'Error! Invalid address format') { console.log('잘못된 주소 형식입니다') }
                if (err) {
                    // console.log(err);
                }
                else if (response?.data?.message === "NOTOK") {//코인 에러처리
                    // console.log('err',response);
                    // console.log(response?.data?.result);
                }
                else if (response?.data?.message === "OK") {
                    // console.log("getStandCoin",response);
                    this.setStandData(response?.data?.result);
                    return;
                }
            });

        }
    }

    setStandData(value) {//setStandData 변수에 저장
        // console.log("setStandData=======================================", value);
        if (value > 0) {
            // let StandCount = Number(value) / 1000000000000000000;
            let StandCount = Number(value);
            // let StandCount = value;
            // console.log('StandCount', StandCount);


            if (value === 0 || value === undefined || value === null) {
                // console.log('StandData======================',value);
                this.GuideStandCoin = '0';
            }
            else {
                this.GuideStandCoin = StandCount;
            }
            this.StandData = StandCount;
        } else {
            this.GuideStandCoin = '0';
            return;
        }

        // console.log(object);
    }

    getEtherCoin = (value) => {//Ether코인 불러오기
        // console.log(value);
        const address = this.WalletData.address;
        // console.log("getEtherCoin=========================", address);
        if (address === undefined || address === null || address === "") {
            // console.log("address");
        }
        else {
            getEtherBalance(address, (err, response) => {
                // if(response?.data?.result === 'Error! Invalid address format') { console.log('잘못된 주소 형식입니다') }
                if (err) {
                    // console.log('EtherDataErr=================================',err);   
                }
                else if (response?.data?.message === "NOTOK") {//코인 에러처리
                    // console.log('err', response);
                    // console.log(response?.data?.result);
                }
                else if (response?.data?.message === "OK") {
                    // console.log(response?.data?.result);
                    this.setEtherData(response?.data?.result);
                }
            });
        }
    }

    setEtherData(value) {//setEtherData 변수에 저장
        // console.log(value);
        let EtherCoin = Number(value) / 1000000000000000000;
        if (value > 0) {
            if (value === "0") {
                this.GuideEtherCoin = '0';
            }
            else if (value === 0) {
                this.GuideEtherCoin = '0';
            }
            else {
                this.GuideEtherCoin = EtherCoin;
            }
            this.EtherData = EtherCoin;
            // console.log("sete = " + this.EtherData);
        } else {
            this.GuideEtherCoin = '0';
            return;
        }
    }

    setUserLockToken(object) {//Lock데이터 변수에 저장
        // console.log(object.lockCount);
        const lockCount = object.lockCount;
        if (lockCount === 0) {
            this.UserLockToken = '00000.0000';
        }
        else {
            this.UserLockToken = object
        }
    }

    getCommissionEther = () => {// 수수료 계산
        const address = this.WalletInput;
        const amount = this.StandInput;
        const CommissionData = { 'member_no': parseInt(this.rootStore.loginStore.loginState.member_no), 'address': String(address), 'amount': Number(amount) }

        console.log('===========================');
        console.log(CommissionData);
        console.log(amount);
        const StandData = this.StandData
        const StandCoinCommission = StandData - amount;
        console.log(StandCoinCommission);


        const getCommissionEtherapi = '/getTokenTranCommisions';
        console.log(-100);
        if (address === null || address === undefined || address === "") { return alert(this.rootStore?.loginStore?.ErrorGuide_clover_007); }//지갑정보를 입력해주세요
        if (amount === null || amount === undefined || amount === "") { return alert(this.rootStore?.loginStore?.ErrorGuide_clover_008); }// 코인수량을 입력해주세요
        if (StandCoinCommission > 0) {
            privatePost({ api: getCommissionEtherapi, data: CommissionData }, (err, response) => {
                if (err) {
                    console.log(err);
                    this.errSendButtonChange("00");
                    const ErrorCode = err.errorCode;
                    if (ErrorCode === 3102) { return alert(this.rootStore?.loginStore?.ErrorGuide_clover_coin_003); }//지갑정보를 찾을 수 없습니다
                    if (address === null || address === undefined || address === "") { return alert(this.rootStore?.loginStore?.ErrorGuide_clover_007); }//지갑정보를 입력해주세요
                    if (amount === null || amount === undefined || amount === "") { return alert(this.rootStore?.loginStore?.ErrorGuide_clover_008); }// 코인수량을 입력해주세요
                    if (ErrorCode === 3100) { return alert(this.rootStore?.loginStore?.ErrorGuide_clover_userProfile_01); }//유저를 찾을 수 없습니다
                } else {
                    console.log(response?.data?.result);
                    this.setCommissionEther(response?.data?.result);
                    return
                }
            });
        }
        else {
            this.errSendButtonChange("00");
            return alert(this.rootStore?.loginStore?.ErrorGuide_clover_009);//수량을 확인해주세요
        }
    }

    errSendButtonChange(e) {//수수료에러 후 버튼 초기화 저장
        this.SendButtonChange = 0;
    }


    setCommissionEther(object) {//수수료계산 결과값 저장
        const CommissionEther = object.commision;
        this.Commission = CommissionEther;
        this.CountEtherCoin = this.EtherData - CommissionEther;
        console.log('EtherData =' + this.EtherData);
        console.log('CommissionEther =' + CommissionEther);
        this.setSendButtonChange("1");
        this.GuideCommission = this.rootStore?.loginStore?.ErrorGuide_clover_006;//수수료가 차이가 있을 수 있습니다!
    }

    WalletTextValue(object) {//지갑입력데이터 저장 (CoinSendPage)
        const WalletValue = object.target.value;
        this.WalletInput = WalletValue;
    }

    StandTextValue(object) {//Stand입력데이터 저장 (CoinSendPage)
        const StandValue = object.target.value
        this.StandInput = StandValue;
    }


    SandCoin = () => {//코인 전송
        const address = this.WalletInput;
        const amount = this.StandInput;

        const StandData = this.StandData;
        const EtherCoinCommission = this.CountEtherCoin;
        const StandCoinCommission = StandData - this.StandInput;

        const CoinTrnasferData = { 'member_no': parseInt(this.rootStore.loginStore.loginState.member_no), 'address': String(address), 'amount': Number(amount) }


        const getsendTokenUserapi = '/sendTokenUser';
        //setBearer(`Bearer1`);
        if (window.confirm(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_01) === true) { //보내시겠습니까?

            if (EtherCoinCommission > 0) {
                if (StandCoinCommission > 0) {

                    privatePost({ api: getsendTokenUserapi, data: CoinTrnasferData }, (err, response) => {
                        if (err) {
                            // console.log(err); 
                            return alert(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02);//취소되었습니다
                        } else {
                            // console.log(response?.data?.result);
                            this.setSandCoinData(response?.data?.result);
                            alert(this.rootStore?.loginStore?.SuccessGuide_message);//완료되셨습니다
                            this.setWalletUpdateStart(true);
                            window.location.href = 'https://www.earn-clover.com/';//전송 완료 후 창 이동
                            return
                        }
                    });
                }
                else {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_clover_005);//코인이 부족합니다
                }
            }

            else {
                return alert(this.rootStore?.loginStore?.ErrorGuide_clover_010);//이더리움이 부족합니다
            }

        }
        else {//취소
            return alert(this.rootStore?.loginStore?.GuideCheck_clover_coinStore_message_02);//취소되었습니다
        }
    }

    setSandCoinData(object) {//코인 전송 결과값 저장
        // console.log(object);
        this.CoinTransferData = object
    }

    /**DB -> 지갑전환 */
    setExchangeMemberStand = () => {
        const api = "/exchangeMemberStand";
        const Amount = parseFloat(this.CalculationCoinChange);
        // console.log(Amount);
        // console.log( typeof Amount);
        privatePost({ api: api, data: { member_no: parseInt(this.rootStore.loginStore.loginState.member_no), amount: Amount } }, (err, response) => {
            if (err) {
                // console.log(err);
                // eslint-disable-next-line
                if (err.errorCode == 3800) {
                    this.setGuideTransferMessage(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요
                    // return alert("잠시후 다시 시도해주세요")
                }
                // eslint-disable-next-line
                else if (err.errorCode == 3801) {
                    this.setGuideTransferMessage(this.rootStore?.loginStore?.ErrorGuide_clover_coin_003);//지갑주소를 찾을 수 없습니다
                    // return alert("지갑주소를 찾을 수 없습니다")
                }
                // eslint-disable-next-line
                else if (err.errorCode == 3802) {
                    this.setGuideTransferMessage(this.rootStore?.loginStore?.ErrorGuide_clover_coin_004);//거래소 정보를 불러 올 수 없습니다
                    // return alert("거래소 정보를 불러 올 수 없습니다")
                }
                // eslint-disable-next-line
                else if (err.errorCode == 3803) {
                    this.setGuideTransferMessage(this.rootStore?.loginStore?.ErrorGuide_clover_coin_005);//코인 전송에 실패하였습니다
                    // return alert("코인 전송에 실패하였습니다")
                }
                // eslint-disable-next-line
                else if (err.errorCode == 3804) {
                    this.setGuideTransferMessage(this.rootStore?.loginStore?.ErrorGuide_clover_coin_006);//수수료가 부족합니다
                    // return alert("수수료가 부족합니다")
                }
            }
            else {
                // console.log(response.data.result);
                this.setExchangeMemberStandData(response?.data?.result);
            }
        });
    }


    setGuideTransferMessage(value) {
        this.GuideTransferMessage = value;
    }


    setExchangeMemberStandData(object) {
        this.ExchangeMemberStandData = object;
    }

    /**DB -> 지갑전환수수료 */
    getExchangeCommissions = (value) => {
        // console.log(value);
        const api = "/getExchangeCommissions";
        privatePost({ api: api, data: { member_no: parseInt(this.rootStore.loginStore.loginState.member_no) } }, (err, response) => {
            if (err) {
                // console.log(err);
                return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
            }
            else {
                this.setCoinTransferData(response?.data?.result);
                // eslint-disable-next-line
                if (value == "All") {
                    this.setCalculationCoinChange(response?.data?.result?.commision);
                }
            }
        });
    }

    setCalculationCoinChange(value) {
        this.CalculationCoinChange = Number(this.DBData) - Number(value);
    }

    setUserCalculationCoinChange(value) {
        // console.log(value.target.value);
        // console.log(value.target.value === "");
        if (value.target.value !== null || value.target.value !== undefined || value.target.value !== "") {
            const Value = String(value.target.value);
            this.CalculationCoinChange = parseFloat(Value);
        }
    }

    setCoinTransferData(object) {
        this.CoinTransferData = object.commision;
    }

    CoinSendRefrash = () => {//My.코인 이체 초기화
        // this.GuideWallet = "전달할 지갑주소를 입력해주세요";
        // this.GuideStand = '전달 할 수량을 입력해 주세요!';
        this.Commission = this.rootStore?.loginStore?.Guide_clover_commission;//확인을 눌러 주세요
        this.SendButtonChange = 0;
    }

    setWalletUpdateStart(bool) {
        this.WalletUpdateStart = bool;
    }

    WalletUpdate = () => {
        // this.getStandCoin();
        this.getWalletData();
    }


    getTransformStandValue = (value) => {
        this.TransformStandValue = value;
    }


    setisDBCoinTransfer(value, bool) {


        // isDBCoinTransferPage = true;
        // isStandExchangePage = false;

        if (value === "DBCoinTransfer") {
            // console.log("DDD");
            this.isDBCoinTransferPage = bool;
            this.isStandExchangePage = false;
        }
        else if (value === "StandExchange") {
            // console.log("SSS");
            this.isStandExchangePage = bool;
            this.isDBCoinTransferPage = false;
        }

    }

    getExchangeCommissionWithWallet() {

        let requestData = {
            member_no: parseInt(this.rootStore.loginStore.loginState.member_no),
        };

        const api = "/getExchangeCommissionWithWallet";

        privatePost({ api: api, data: requestData }, (err, response) => {
            if (err) {
                // console.log(err);
                // return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
                // return alert(this.rootStore?.loginStore?.ErrorGuide_501);//
                if (err.errorCode === 501) {
                    this.grade_error_clover_exchange = this.rootStore?.loginStore?.ErrorGuide_501; //잠시후 다시 시도해주세요.
                    // RECOMMENDER CUT
                    // return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
                }
                else {
                    this.grade_error_clover_exchange = this.rootStore?.loginStore?.ErrorGuide_clover_001; //새로고침을 시도해주세요.
                    // return alert(this.rootStore?.loginStore?.ErrorGuide_clover_001);//새로고침을 시도해주세요.
                }
            }
            else {
                // console.log(response?.data?.result);
                // {
                //     exchange_krw,
                //         exchange_commission,
                //         address,
                //         balance,
                //         lockCount,
                //         lockInfo,
                // }
                if (response?.data?.result) {

                    if (response?.data?.result?.lockValue && response?.data?.result?.lockInfo)
                        this.setUserCoinLockTokenState(response?.data?.result);
                    this.setStandData(response?.data?.result?.balance);
                    this.setRealTokenToDBCommission(response?.data?.result?.exchange_commission);
                    // exchangeReservationList
                    this.setExchangeKRW(response?.data?.result?.exchange_krw);
                    this.setExchangeReservationList(response?.data?.result?.exchangeReservationList);
                    this.setTokenToCloverExchangeReservationList(response?.data?.result?.cloverExchangeReservationList);
                } else {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
                }
            }
        });


        // const StandData = this.StandData;
        // const EtherCoinCommission = this.CountEtherCoin - this.DBExchangeCommission;
        // const StandCoinCommission = StandData - exchangeValue;

        // console.log("================================ setDBExchangeValueStand");
        // console.log("StandData = "+StandData);
        // console.log("EtherCoinCommission = "+EtherCoinCommission);
        // console.log("StandCoinCommission = "+StandCoinCommission);

        // if (EtherCoinCommission > 0) {
        //     if (StandCoinCommission > 0) {

        //         privatePost({ api: api, data: Data }, (err, response) => {
        //             if (err) {
        //                 // console.log(err);
        //                 return alert(this.rootStore?.loginStore?.ErrorGuide_501);//취소되었습니다
        //             } else {
        //                 // console.log(response?.data?.result);
        //                 this.getDBCoin();
        //             }
        //         });
        //     }
        //     else {
        //         return alert(this.rootStore?.loginStore?.ErrorGuide_clover_005);//코인이 부족합니다
        //     }
        // }

        // else {
        //     return alert(this.rootStore?.loginStore?.ErrorGuide_clover_010);//이더리움이 부족합니다
        // }

    }
    polygonTokenChangeToDBToken() {
        // let exChangeData = {
        //     member_no: data.member_no,
        //     member_address: data.member_address, 
        //     real_token_count: data.real_token_count, //insert db token + fee
        //     db_token_count: data.db_token_count, // insert db token
        //     exchange_fee: data.exchange_fee, // 수수료 
        //     exchange_price: data.exchange_price,  //토큰 가격 
        // };


        let needRealToken = parseFloat(this.DBExchangeDataValue) + parseFloat(this.RealTokenToDBCommission);
        let exchangeDBToken = parseFloat(this.DBExchangeDataValue);
        let needFee = parseFloat(this.RealTokenToDBCommission);
        let exchangePrice = parseFloat(this.ExChangeKRW);
        // console.log(exchangeValue);


        let requestData = {
            member_no: parseInt(this.rootStore.loginStore.loginState.member_no),
            member_address: this.WalletData.address,
            real_token_count: needRealToken,
            db_token_count: exchangeDBToken, // insert db token
            exchange_fee: needFee, // 수수료 
            exchange_price: exchangePrice,  //토큰 가격 
        };
        const api = "/polygonTokenChangeToDBToken";

        privatePost({ api: api, data: requestData }, (err, response) => {
            if (err) {
                // console.log(err);



                if (err == 100 || err == 1 || err == 92)
                    return alert(this.rootStore?.loginStore?.DBTokenExchange_dialog_err_0);
                else
                    return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
                //0 스탠드정보 에러
                //1 매틱 겟 에러
                //2 토큰 전송 에러
                //3 토큰 전송 후 테이블 컴플리트 체크 에러
                //5 해당 지갑 매틱 전송 에러
                //6 매틱 전송 정보 수정 에러
                //7 매틱 전송 정보 업데이트 에러
                //10 스탠드 겟 에러
                //11 스탠드 업데이트 에러
                //12 히스토리 기입 에러\
                //31 가스비 계산 에러
                //90 지갑정보 못찾음
                //91 지갑정보 틀림
                //92 토큰 설정값 확인 필요
                //100 스탠드 부족



            }
            else {
                // console.log(response?.data);
                //true 1 - 환전 완료
                //ture 2 - 환전 대기 시간 소요
                if (response?.data?.result) {
                    // id, member_no, member_address, real_token_count, db_token_count, exchange_price,
                    // exchange_fee, insert_change_coin, insert_coin_value, change_time, complete_change, complete_time

                    // if (response?.data?.result?.length)
                    if (response?.data?.result?.lockValue && response?.data?.result?.lockInfo)
                        this.setUserCoinLockTokenState(response?.data?.result);
                    this.setEtherData(response?.data?.result?.balance);
                    this.setDBExchangeValueCommission(response?.data?.result?.exchange_commission);
                    this.setExchangeReservationList(response?.data?.result?.exchangeReservationList);
                    this.setTokenToCloverExchangeReservationList(response?.data?.result?.cloverExchangeReservationList)
                    return alert(this.rootStore?.loginStore?.DBTokenExchange_dialog_sucess);//환전신청 완료 메시지 .

                } else {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
                }
            }

        });

    }

    setDBExchangeDataValue(value) {

        // console.log(value);
        // this.StandData
        // this.DBExchangeCommission
        // this.NotCompleteDBExchangeReservationList
        // this.UserCoinLockTokenData.lockValue
        let stand = this.StandData;
        let minusValue = 0;

        if (this.UserCoinLockTokenValue > 0)
            minusValue += this.UserCoinLockTokenValue;
        let reservationList = this.NotCompleteDBExchangeReservationList;
        if (reservationList.length) {
            for (var i = 0; i < reservationList.length; i++) {
                minusValue += reservationList[i].real_token_count;
            }
        }
        let tokenToCloverReservationList = this.NotCompleteTokenToCloverExchangeList;
        if (tokenToCloverReservationList.length) {
            for (var i = 0; i < tokenToCloverReservationList.length; i++) {
                minusValue += tokenToCloverReservationList[i].real_token_count;
            }
        }

        let commission = this.RealTokenToDBCommission;

        if (stand - (minusValue + commission) <= 0) {
            this.DBExchangeDataValue = 0;
        }
        else {
            if (value == 'max') {
                this.DBExchangeDataValue = stand - (minusValue + commission)
            } else {

                if (value > stand - (minusValue + commission)) {
                    this.DBExchangeDataValue = stand - (minusValue + commission);
                }
                else {
                    this.DBExchangeDataValue = value;
                }
            }
        }

        // this.DBExchangeDataValue = value;

        // this.DBExchangeDataValue = "";
        // this.DBExchangeData = {};
        // this.DBExchangeCommission = {};

    }


    getDBExchangeValueCommission(Check) {

        // console.log(Check);

        let exchangeValue = this.DBExchangeDataValue;

        // console.log(exchangeValue);

        let UserCommissionData = {
            member_no: parseInt(this.rootStore.loginStore.loginState.member_no),
            amount: parseFloat(exchangeValue),
            address: "MissionAddress",
        };
        // console.log("============================ getDBExchangeValueCommission");
        // console.log("exchangeValue = "+exchangeValue); 

        const api = "/getTokenTranCommisions";
        console.log(-101);
        privatePost({ api: api, data: UserCommissionData }, (err, response) => {
            if (err) {
                // console.log(err);
                return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시후 다시 시도해주세요.
                // return alert(this.rootStore?.loginStore?.ErrorGuide_501);//
            }
            else {
                // console.log(response?.data?.result);
                this.setDBExchangeValueCommission(response?.data?.result?.commision);
            }
        });

    }

    setDBExchangeValueCommission(value) {
        // console.log(value);
        this.DBExchangeCommission = value;
    }

    setRealTokenToDBCommission(value) {
        this.RealTokenToDBCommission = value;
    }
    setDBExchangeValueStand(Check) {

        // console.log(Check);


        let exchangeValue = this.DBExchangeDataValue;

        // console.log(exchangeValue);

        let Data = {
            member_no: parseInt(this.rootStore.loginStore.loginState.member_no),
            amount: parseFloat(exchangeValue),
            commission: parseFloat(this.DBExchangeCommission),
            address: "MissionAddress"
        };

        const api = "/setdbExchangeStand";

        const StandData = this.StandData;
        const EtherCoinCommission = this.CountEtherCoin - this.DBExchangeCommission;
        const StandCoinCommission = StandData - exchangeValue;

        // console.log("================================ setDBExchangeValueStand");
        // console.log("StandData = "+StandData);
        // console.log("EtherCoinCommission = "+EtherCoinCommission);
        // console.log("StandCoinCommission = "+StandCoinCommission);

        if (EtherCoinCommission > 0) {
            if (StandCoinCommission > 0) {

                privatePost({ api: api, data: Data }, (err, response) => {
                    if (err) {
                        // console.log(err);
                        return alert(this.rootStore?.loginStore?.ErrorGuide_501);//취소되었습니다
                    } else {
                        // console.log(response?.data?.result);
                        this.getDBCoin();
                    }
                });
            }
            else {
                return alert(this.rootStore?.loginStore?.ErrorGuide_clover_005);//코인이 부족합니다
            }
        }

        else {
            return alert(this.rootStore?.loginStore?.ErrorGuide_clover_010);//이더리움이 부족합니다
        }


    }



    getMemberLockTokenData(Check) {// lockTokenDataCall

        // console.log(Check);

        // let exchangeValue = this.DBExchangeDataValue;

        // console.log(exchangeValue);

        let Data = {
            member_no: parseInt(this.rootStore.loginStore.loginState.member_no),
            address: String("MissionAddress"),
        };
        //실제토큰 lockData
        const api = "/getMemberLockToken";



        privatePost({ api: api, data: Data }, (err, response) => {
            if (err) {
                // console.log(err);
                if (err.errorCode === 704) {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_clover_001);//잠시 후 다시 시도해주세요
                }
                else {
                    return alert(this.rootStore?.loginStore?.ErrorGuide_501);//잠시 후 다시 시도해주세요
                }
            } else {
                // console.log(response?.data?.result);
                this.setUserCoinLockTokenState(response?.data?.result);
            }
        });




    }

    setExchangeReservationList(list) {
        let completeList = [];
        let notCompleteList = [];
        if (list.length) {
            for (var i = 0; i < list.length; i++) {
                if (list[i].complete_change == true) {
                    completeList.push(list[i]);
                } else {
                    notCompleteList.push(list[i]);
                }
            }

        }
        this.NotCompleteDBExchangeReservationList = notCompleteList;
        this.CompleteDBExchangeReservationList = completeList;
    }
    setTokenToCloverExchangeReservationList(list) {
        let completeList = [];
        let notCompleteList = [];
        if (list.length) {
            for (var i = 0; i < list.length; i++) {
                if (list[i].complete_change == true) {
                    completeList.push(list[i]);
                } else {
                    notCompleteList.push(list[i]);
                }
            }

        }
        this.NotCompleteTokenToCloverExchangeList = notCompleteList;
        this.CompleteTokenToCloverExchangeList = completeList;
    }

    setExchangeKRW(value) {
        this.ExChangeKRW = value;
    }
    setUserCoinLockTokenState(coinLockTokenData) {
        this.UserCoinLockTokenValue = coinLockTokenData.lockValue;
        this.UserCoinLockTokenDatainfo = coinLockTokenData?.lockInfo;

    }






}